import { render, staticRenderFns } from "./LayoutStudioInput.vue?vue&type=template&id=aae0c9ca&"
import script from "./LayoutStudioInput.vue?vue&type=script&lang=ts&"
export * from "./LayoutStudioInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports